<template>
    <div class="ur-data-grid__edit__element ur-data-grid__edit__checkbox" :class="checkClass" @mousedown.stop="()=>{}">
        <ur-icon class="ur-data-grid__edit__icon ur-data-grid__edit__checkbox__icon" iconType="picto"
                 ref="check" :icon="iconText" @click="onClick" tabindex="0"
                 @keydown.space.prevent="onClick"/>
    </div>
</template>

<script>
export default {
    name : 'urDataGridEditCheckbox',
    props : {
        value : [String, Boolean, Object]
    },
    data() { return {
        currVal: '', // value for "input" element
    }},
    computed : {
        // [COMPUTED] Values
        iconText() {return this.currVal?'checked':'box'},
        // [COMPUTED] style & classes
        checkClass() {
            return {'ur-data-grid__edit__checkbox--checked':this.currVal}
        }
    },
    watch : {
        value: {immediate: true, handler(val, old) {
            var v;
            // 1. check null (null -> true -> false)
            if(val === null || val === undefined) {v = false}
            // 2. type boolean
            else if(typeof val === 'boolean') {v = val}
            // 3. check Object?
            else if(typeof val === 'object') {
                console.warn('[UIDev] Checkbox cannot control an object value. It will be changed to true/false.')
                v = true
            }
            // 4. check Y/N
            else if(val === 'Y' || val === 'y') {v = true}
            else if(val === 'N' || val === 'n') {v = false}
            // 5. check 'true'/'false'
            else if(val === 'true')  {v = true}
            else if(val === 'false') {v = false} // WARNING! side effect 가능성, 근데 boolean field에 'false' 들어오면 false 아닐까?
            // 6. type string
            else if(typeof val === 'string') {
                console.warn('[UIDev] Checkbox cannot control an string value. It will be changed to true/false.')
                v = !!val
            }
            // x. set to local variable
            this.currVal = v; // when input comes
        }}
    },
    methods : {
        // [METHODS] events
        onClick() {
            // 1. set to myself
            this.currVal = !this.currVal;
            // 2. prepare emit value -> inverse of "this.value"
            var val = this.value, v;
            // 2.1 check value is null
            if(val === null || val === undefined || val === '') {v = true}
            // 2.2 check value is boolean
            else if(typeof val === 'boolean') {v = this.currVal}
            // 2.3 check Object
            else if(typeof val === 'object') { v = false }
            // 2.4 check Y/N
            else if(val === 'Y') {v = 'N'}
            else if(val === 'y') {v = 'n'}
            else if(val === 'N') {v = 'Y'}
            else if(val === 'n') {v = 'y'}
            // 2.5 check 'true'/'false'
            else if(val === 'true')  {v = 'false'}
            else if(val === 'false') {v = 'true'}
            // 2.6 type string
            else if(typeof val === 'string') {v = false}
            // 2.x else?
            else {v = this.currVal}
            
            // x. emit value 
            this.$emit('input',v);
        },
        focus(opts) {
            this.$refs.check.focus(opts);
        }
    }
};
</script>
